import angular from 'angular';
import adminpulse from '@/shared/utils/adminpulse';

angular
  .module('cxInvoicing')
  .controller('PreviewDraftInvoiceDialogCtrl', [
    '$element',
    'close',
    'invoice',
    'finalize',
    'appUrls',
    '$http',
    '$timeout',
    'flySvc',
    'FileSaver',
    previewDraftInvoiceDialogCtrl,
  ]);

function previewDraftInvoiceDialogCtrl(
  $element,
  close,
  invoice,
  finalize,
  appUrls,
  $http,
  $timeout,
  flySvc,
  FileSaver,
) {
  var vm = this;
  vm.invoice = invoice;
  vm.showSaveButtons = typeof finalize === 'function';
  vm.numbering = false;
  vm.sending = false;
  vm.invoicePreviewImage = null;
  vm.loadingPreview = true;

  var showArrayBufferError = function(error) {
    if (!error) return;
    try {
      var buffer = error.data || error;
      const errorObject = adminpulse.arrayBufferToObject(buffer) || {};
      flySvc.error(errorObject);
    } catch (ex) {
      console.error(ex);
      //Parsing error?
      flySvc.error();
    }
  };

  vm.downloadPdf = () => {
    $http
      .get(`${appUrls.api}/api/draftInvoice/PreviewPdf/${invoice.id}`, {
        responseType: 'arraybuffer',
      })
      .then(result => {
        const contentDisposition = result.headers('Content-Disposition');
        const filename = adminpulse.getFileNameFromHeader(contentDisposition);

        const blob = new Blob([result.data], { type: 'application/pdf' });
        if (blob) {
          FileSaver.saveAs(blob, filename);
        }
      });
  };

  vm.generatePreview = function() {
    vm.loadingPreview = true;
    vm.invoicePreviewImage = null;
    $http
      .get(`${appUrls.api}/Api/DraftInvoice/Preview/${vm.invoice.id}?now=${new Date().getTime()}`, {
        responseType: 'arraybuffer',
      })
      .then(
        response => {
          vm.loadingPreview = false;
          if (!response || !response.data) return;
          var blob = new Blob([response.data], { type: 'image/png' });
          var reader = new FileReader();
          reader.onload = function(evt) {
            $timeout(function() {
              vm.invoicePreviewImage = evt.target.result;
            }, 0);
          };
          reader.readAsDataURL(blob);
        },
        error => {
          vm.loadingPreview = false;
          showArrayBufferError(error);
        },
      );
  };
  vm.generatePreview();
  vm.save = function(sendMail) {
    var promise = finalize(invoice, sendMail);
    if (promise) {
      if (sendMail) {
        vm.sending = true;
      } else {
        vm.numbering = true;
      }
      promise.then(
        function() {
          vm.sending = false;
          vm.numbering = false;
          $element.modal('hide');
          close(true, 500);
        },
        function(error) {
          vm.sending = false;
          vm.numbering = false;
        },
      );
    }
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
